import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import {
  GaTrackingEventAction,
  GaTrackingEventCategory,
  GaTrackingEventName
} from '~shared/modules/ga-tracking/constants';

export class FlixmediaFailedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.FlixMediaFailed;
  event = GaTrackingEventName.FlixMediaError;
  category = GaTrackingEventCategory.Errors;
  action: GaTrackingEventAction.FlixMediaFailed;

  constructor(private label: string) {}

  getPayload(): any {
    return {
      type: this.type,
      event: this.event,
      category: this.category,
      label: this.label,
      action: this.action,
      gtmCustom: {
        category: this.category
      }
    };
  }
}

